<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" v-if="showModal"
        width="780px">
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-form-item label="请选择类型" prop="type">
                <el-select v-model="form.type">
                    <el-option label="实物" :value="2" />
                    <el-option label="积分" :value="1" />
                    <el-option label="谢谢惠顾" :value="3" />
                </el-select>
            </el-form-item>

            <template v-if="form.type === 1">
                <el-form-item label="请输入积分" prop="worth">
                    <el-input v-model="form.worth" />
                </el-form-item>
            </template>

            <template v-if="form.type === 2">
                <el-form-item label="实物标题" prop="title">
                    <el-input v-model="form.title" />
                </el-form-item>

                <el-form-item label="图片(60*60倍数)" prop="img">
                    <upload-one v-model="form.img" width="260px" height="260px"></upload-one>
                </el-form-item>

                <el-form-item label="实物价值" prop="worth">
                    <el-input type="number" v-model="form.worth" oninput="if(value>100000000)value=99999999" maxlength="8"
                        max="99999999" />
                </el-form-item>
            </template>
            <div style="color: red;padding: 0 0 0 55px;">
                <p> 中奖概率说明：当前奖品概率 除以 所有奖品概率相加（包括谢谢惠顾）</p>
                <div>
                    <p style="padding:0 0 0 5em"> 如：之前总和为 1000（中奖概率相加,谢谢惠顾 + 奖品 总概率）</p>
                    <p style="padding:0 0 0 7em"> 现输入 10 ，则当前新增中奖概率为 10/(1000+10)</p>
                    <!-- <p style="padding:0 0 0 4em">备注：概率为 0.0001 到 99999999</p> -->
                </div>
            </div>
            <el-form-item label="中奖概率" prop="probability">
                <el-input v-model="form.probability" @input="validateProbability" />
            </el-form-item>

            <el-form-item v-if="form.type !== 3" label="奖品数量" prop="prize_num">
                <el-input v-model="form.prize_num" />
            </el-form-item>

            <el-form-item label="权重" prop="sort">
                <el-input-number v-model="form.sort" :min="1" :max="9999"></el-input-number>
            </el-form-item>
            <el-row type="flex" justify="end">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" @click="submitForm('form')">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { prize } from "@/api/draw.js"

export default {
    data: () => ({
        rules: {
            title: [
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
            img: [
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
            worth: [
                { required: true, message: '不能为空', trigger: 'blur' },
                {
                    validator: (rule, value, cb) => {
                        if (value < 1) cb(new Error('请输入大于0数'))
                        cb()
                    }, trigger: 'change'
                },
            ],
            probability: [
                { required: true, message: '不能为空', trigger: 'blur' },
                {
                    validator: (rule, value, cb) => {
                        if (value < 0.0001 || value > 99999999) cb(new Error('中奖概率为 0.0001 到 99999999'))
                        cb()
                    }, trigger: 'blur'
                },
            ],
            prize_num: [
                { required: true, message: '不能为空', trigger: 'blur' },
                {
                    validator: (rule, value, cb) => {
                        if (value < 1 || !/^\d+$/.test(value)) cb(new Error('请输入大于0的整数'))
                        cb()
                    }, trigger: 'change'
                },
            ]
        },
        form: {
            id: null,
            type: 2,
            title: '',
            worth: 0,
            img: null,
            probability: '',
            prize_num: '',
            sort: 1
        },
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        validateProbability() {
            // 匹配输入是否符合要求的正则表达式
            const regex = /^(\d+)?(?:\.\d*)?$/;

            // 判断输入是否符合要求
            if (!regex.test(this.form.probability)) {
                // 如果不符合要求，则将输入中的非数字和非小数点字符替换为空字符
                this.form.probability = this.form.probability.replace(/[^\d.]/g, '');

                // 判断小数点的个数
                const dotCount = (this.form.probability.match(/\./g) || []).length;

                // 如果小数点超过一个，则将最后一个小数点去除
                if (dotCount > 1) {
                    const lastIndex = this.form.probability.lastIndexOf('.');
                    this.form.probability = this.form.probability.slice(0, lastIndex) + this.form.probability.slice(lastIndex + 1);
                }
            }
        },
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        id: null,
                        type: 2,
                        title: '',
                        worth: '',
                        img: null,
                        probability: '',
                        prize_num: '',
                        sort: 1
                    }
                },
                edit: () => {
                    const { id, title, type, worth, img, probability, prize_num, sort } = this.editData
                    this.form = {
                        id,
                        type,
                        title,
                        worth,
                        img,
                        probability,
                        prize_num,
                        sort
                    }
                }
            }

            handlers[this.type]()
        },
        // 提交
        submitForm(formName) {
            
            const { type, form } = this

            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        await prize.add(form)
                        this.trunOff()
                        this.$message({
                            message: `${type === "add" ? '新建' : '修改'}奖品成功`,
                            type: 'success'
                        });
                        this.$emit("onUpdate")
                    } catch {
                        // this.$message.error('出错了!');
                    }
                }
            });
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.ipt-box {
    // max-width: 512px;
    display: flex;
    align-items: center;
    margin-bottom: 22px;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>